module.exports = __webpack_public_path__ + "static/media/InfoIcon.6f1efbed.svg";